import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { LiaFileExcel } from 'react-icons/lia';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { BarLoader } from 'react-spinners';
import Pagination from '../pagination/pagination';
import { useCurrency } from '../../Layouts/currencyContext';


const InvoiceReport = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [PoList, setPOlist] = useState();
    const [currencyPrecision, setPrecision] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [toDate, setToDate] = useState();
    const [fromDate, setFromDate] = useState();
    const [dateFilter, setdateFilter] = useState(false);
    const [SupplierList, setSuppliers] = useState();
    const gridRef = useRef();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        email: '',
        InvoiceNo: "",
        costcenter3: "",
        SupplierName: [{ label: 'Select Supplier', value: '' }],
        supplierId: [{ label: 'Select Supplier Id', value: '' }],
        Status: [{ label: 'Filter By', value: '' }],
        PONo: [{ label: 'Select PO', value: 'Select PO' }],
    });

    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setFromDate(today);
        setToDate(today);
    }, []);

    useEffect(() => {
        fetchDropdownData();
        // getItems()
    }, []);
    const fetchDropdownData = async () => {
        try {
            const apiService = new ApiService();
            let param = `?isActive=true`
            let Currencyres = await apiService.get('GET_CURRENCY_MASTER')
            const filteredDenominations = Currencyres?.data?.result?.find(currency => currency?.isDefault === true);
            setPrecision(filteredDenominations?.precision)
            const requsition = await apiService.getApiParamater("GET_PO", param);
            const suppliers = await apiService.get('GET_SUPPLIER');
            setSuppliers(suppliers?.data?.result);
            setPOlist(requsition?.data.result)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {

            const apiService = new ApiService();
            const params = new URLSearchParams({
                VendorName: formData?.SupplierName?.label || "",
                Status: formData.Status.value || "",
                FromDate: formData.fromDate || "",
                ToDate: formData.toDate || "",
                POrderNo: formData.PONo.value?.pOrderNo || "",
                InvoiceRegNo: formData.InvoiceNo || "",
                CostCenter3: formData.costcenter3 || "",
            });

            if (dateFilter === true) {
                params.append('FromDate', fromDate || "");
                params.append('ToDate', toDate || "");
            }
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);

            const res = await apiService.getApiParamater('GET_INVOICE_REPORT', `?${params.toString()}`);
            setRowData(res?.data?.result?.reverse() || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const StatusFilter = [
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Aproved' },
        { value: '2', label: 'Hold' },
        { value: '3', label: 'Rejected' },
    ]
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const Comparison = [
        { headerName: 'Invoice Reg No', field: 'invoiceRegNo', width: 150 },
        { headerName: 'Invoice No ', field: 'invoiceNo', width: 140 },
        {
            headerName: 'Invoice Date', field: 'invoiceDate', width: 150,

            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Invoice Ref', field: 'invoiceRef', width: 110 },
        { headerName: 'Invoice Type', field: 'stockType', width: 110 },
        {
            headerName: 'Supplier Invoice Date', field: 'docDate', width: 150,

            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Terms', field: 'terms', width: 150 },
        { headerName: 'Po No', field: 'pOrderNo', width: 150 },
        { headerName: 'Vendor Name', field: 'vendorName', width: 150 },
        { headerName: 'Currency Code', field: 'currencyCode', width: 110 },
        { headerName: 'Exch Rate', field: 'exchangeRate', width: 110 },
        {
            headerName: 'Amount', field: 'amount', width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 3)
        },
    ]
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    }
    const handlePOChange = (selectedOption) => {
        setFormData({ ...formData, PONo: selectedOption });
    }
    const handleSupplierChange = (selectedOption) => {
        setFormData({ ...formData, SupplierName: selectedOption });
    }
    const handleSupplierIdChange = (selectedOption) => {
        setFormData({
            ...formData,
            SupplierId: { value: selectedOption.value, label: selectedOption.label },
            SupplierName: { value: selectedOption.value, label: selectedOption.value?.supplierName }
        });
    }
    const handleStatusFilter = (selectedOption) => {
        setFormData({ ...formData, Status: selectedOption });
    }
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'InvoiceReport.csv'
        });
    }, []);    
    const onBtExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams({
                VendorName: formdata?.SupplierName?.label || "",
                Status: formdata.Status.value || "",
                FromDate: formdata.fromDate || "",
                ToDate: formdata.toDate || "",
                POrderNo: formdata.PONo.value?.pOrderNo || "",
                InvoiceRegNo: formdata.InvoiceNo || "",
                CostCenter3: formdata.costcenter3 || "",
            });

            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);

            const res = await apiService.getApiParamater('GET_INVOICE_REPORT', `?${params.toString()}`);
            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                return;
            }

            const totalAmount = allData.reduce((sum, item) => sum + (item.amount || 0), 0);

            const excelData = allData.map((item) => ({
                'Invoice Reg No': item.invoiceRegNo,
                'Invoice No': item.invoiceNo,
                'Invoice Date': moment(item.invoiceDate).format('DD-MMM-YYYY'),
                'Invoice Ref': item.invoiceRef,
                'Invoice Type': item.stockType,
                'Supplier Invoice Date': moment(item.docDate).format('DD-MMM-YYYY'),
                'Terms': item.terms,
                'Po No': item.pOrderNo,
                'Vendor Name': item.vendorName,
                'Currency Code': item.currencyCode,
                'Exch Rate': item.exchangeRate,
                'Amount': Number(item.amount || 0).toFixed(currencyPrecision || 3),
            }));

            excelData.push({}); // Add an empty row for spacing

            const totalRow = {
                'Invoice Reg No': '',
                'Invoice No': '',
                'Invoice Date': '',
                'Invoice Ref': '',
                'Invoice Type': '',
                'Supplier Invoice Date': '',
                'Terms': '',
                'Po No': '',
                'Vendor Name': '',
                'Currency Code': '',
                'Exch Rate': 'Total',
                'Amount': Number(totalAmount || 0).toFixed(currencyPrecision || 3),
            };
            excelData.push(totalRow);

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Report');

            XLSX.writeFile(workbook, 'InvoiceReport.xlsx');

            toast.success('InvoiceReport.xlsx downloaded');
        } catch (err) {
            console.log(err);
            toast.error('Something went wrong');
        }
    }, [currencyPrecision]);

    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = [
            'invoiceRegNo',
            'invoiceNo',
            'invoiceDate',
            'docDate',
            'terms',
            'pOrderNo',
            'vendorName',
            'amount',
        ];

        comparisonFields.forEach(field => {
            const header = Comparison.find(col => col.field === field).headerName;
            columnHeaders.push(header);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                let value = node.data[field];
                row.push(value);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Item Master Report", 75, 12);
        doc.text("__________________________", 60, 15);
        doc.setLineWidth(2);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 6,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 6,
            },
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 25 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
                6: { cellWidth: 20 },
                7: { cellWidth: 20 },
            },
            startY: 20,
            theme: 'striped'
        });
        doc.save('InvoiceReport.pdf');
    }, []);
    const handlePageSizeChange = (event) => {
        const newSize = Number(event.target.value);
        setPageSize(newSize);
        gridRef.current.api.paginationSetPageSize(newSize);
    }
    const handleClearFilters = () => {
        setFormData({
            email: "",
            InvoiceNo: "",
            costcenter3: "",
            SupplierName: [{ label: 'Select Supplier', value: '' }],
            supplierId: [{ label: 'Select Supplier Id', value: '' }],
            Status: [{ label: 'Filter By', value: '' }],
            PONo: [{ label: 'Select PO', value: 'Select PO' }],
        });
        setFromDate("")
        setToDate(" ")
        setdateFilter(false)
        getItems()
    }
    const handleFromDate = (e) => {
        setFromDate(e.target.value);
    };
    const handleToDate = (e) => {
        setToDate(e.target.value);
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row pb-2' >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.supplierId}
                                onChange={(selectedOption) => handleSupplierIdChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.record_Id }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.SupplierName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='number'
                                className="form-Input w-100"
                                id="validationCustom02"
                                value={formData.InvoiceNo}
                                name="InvoiceNo"
                                onChange={handleInputChange}
                                placeholder='Invoice No'
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={handleStatusFilter}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.PONo}
                                onChange={(selectedOption) => handlePOChange(selectedOption)}
                                options={PoList?.map((rec) => ({ value: rec, label: `${rec?.pOrderNo}` }))}
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='number'
                                className="form-Input w-100"
                                id="validationCustom02"
                                value={formData.costcenter3}
                                name="costcenter3"
                                onChange={handleInputChange}
                                placeholder='costcenter3'
                            />
                        </div>
                        <div className='col-6 d-flex justify-content-between' >
                            <div className='' >
                                <input
                                    type='date'
                                    className="form-Input w-100"
                                    value={fromDate}
                                    name="fromDate"
                                    disabled={!dateFilter}
                                    onChange={handleFromDate}
                                    placeholder='From  Date '
                                />
                            </div>
                            <div className=''  >
                                <input
                                    type='date'
                                    disabled={!dateFilter}
                                    className="form-Input w-100"
                                    placeholder='To  Date '
                                    value={toDate}
                                    name="toDate"
                                    onChange={handleToDate}
                                />
                            </div>
                            <div className=' gap-2 center'>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="dateFilter" style={{ width: "20px", height: "20px" }}
                                    name="dateFilter"
                                    checked={dateFilter}
                                    onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                                <label className=''>Date Filter</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Invoice Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection={'single'}
                            columnDefs={Comparison}
                            ref={gridRef}
                            suppressExcelExport={true}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div >
    );
};
export default InvoiceReport;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};